// extracted by mini-css-extract-plugin
export default {"container":"bR-z","title":"cR-z","link":"dR-z"};